import React from "react";

function PageLoader(props) {
  return (
    <div className="min-h-screen w-full bg-slate-100 pt-24">
      {!props.children && <div className="p-10 text-center">Loading ...</div>}

      {props.children && <>{props.children}</>}
    </div>
  );
}

export default PageLoader;
